<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-large"
    title="イントラネットFW プラットフォームゲートウェイ ゾーン接続 追加"
  >
    <template v-slot:body="{ cancel }">
      <validation-observer v-slot="{ handleSubmit }" as="div">
        <v-form novalidate @submit.stop.prevent="handleSubmit(submit)">
          <v-card-text class="pa-0">
            <div class="modal-body">
              <v-container>
                <!-- 送信元・宛先で同じゾーンを選択したらエラーとする is_notで異なる選択を強要 -->
                <v-row>
                  <v-col>
                    <validation-provider
                      name="srcZoneId"
                      v-model="srcZoneId"
                      label="送信元ゾーン"
                      :rules="{
                        required: true,
                        is_not_eq: {
                          target: '@dstZoneId',
                          targetField: '宛先ゾーン',
                        },
                      }"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-badge item="送信元ゾーン" :isInfo="false" />
                      <app-select
                        :items="srcZoneList"
                        item-title="text"
                        item-value="value"
                        v-bind="componentField"
                        :error-messages="errorMessage"
                        :field-meta="meta"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <validation-provider
                      name="dstZoneId"
                      v-model="dstZoneId"
                      label="宛先ゾーン"
                      :rules="{
                        required: true,
                        is_not_eq: {
                          target: '@srcZoneId',
                          targetField: '送信元ゾーン',
                        },
                      }"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-badge item="宛先ゾーン" :isInfo="false" />
                      <app-select
                        :items="dstZoneList"
                        item-title="text"
                        item-value="value"
                        v-bind="componentField"
                        :error-messages="errorMessage"
                        :field-meta="meta"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
              </v-container>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-list-item class="w-100 pa-1">
              <template v-slot:append>
                <v-btn variant="flat" color="primary" type="submit">追加</v-btn>
                <v-btn variant="outlined" color="primary" @click="cancel"
                  >キャンセル
                </v-btn>
              </template>
            </v-list-item>
          </v-card-actions>
        </v-form>
      </validation-observer>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type { PfgwZone, PfgwZonePut } from "@/apis/PfgwZoneApi";
import { VueFinalModal } from "vue-final-modal";
import AppSelect from "@/components/AppSelect.vue";

export default defineComponent({
  name: "IntranetFwPfgwZoneRelationRegister",
  components: { AppSelect },
  props: {
    enumberAct: {
      type: String as PropType<string>,
      required: true,
    },
    pfgwZone: {
      type: Object as PropType<PfgwZone>,
      required: true,
    },
  },
  data() {
    return {
      srcZoneId: null,
      dstZoneId: null,
      srcZoneList: [] as { value: string; text: string }[],
      dstZoneList: [] as { value: string; text: string }[],
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      const zoneList = [
        { value: this.pfgwZone.wvs2ZoneId, text: "WVS2" },
        { value: this.pfgwZone.kcpsZoneId, text: "KCPS" },
      ];
      // 0件の場合に両方向設定可能とする。
      if (this.pfgwZone.zoneIdList.length === 0) {
        this.srcZoneList = zoneList;
        this.dstZoneList = zoneList;
      } else {
        // 設定済ゾーンの逆方向のリストを作成
        this.srcZoneList = [
          {
            value: this.pfgwZone.zoneIdList[0].dstZoneId,
            text:
              this.pfgwZone.zoneIdList[0].dstZoneId === this.pfgwZone.wvs2ZoneId
                ? "WVS2"
                : "KCPS",
          },
        ];
        this.dstZoneList = [
          {
            value: this.pfgwZone.zoneIdList[0].srcZoneId,
            text:
              this.pfgwZone.zoneIdList[0].srcZoneId === this.pfgwZone.wvs2ZoneId
                ? "WVS2"
                : "KCPS",
          },
        ];
      }
    },
    /** 追加ボタン押下時の挙動*/
    async submit() {
      await this.$confirm("ゾーン接続を追加します。よろしいですか？");

      const reqData: PfgwZonePut = {
        wvs2AddressList: this.pfgwZone.wvs2AddressList.map((e) => e.ipAddress),
        kcpsAddressList: this.pfgwZone.kcpsAddressList.map((e) => e.ipAddress),
        zoneIdList: [
          ...this.pfgwZone.zoneIdList,
          { srcZoneId: this.srcZoneId!, dstZoneId: this.dstZoneId! },
        ],
        pfgwAddressKeyId: this.pfgwZone.pfgwAddressKeyId,
      };

      await this.$api.pfgwZoneRelation.putPfgwZone(this.enumberAct, reqData);
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
  },
});
</script>
